import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Cookies from 'js-cookie';
import {useTranslation} from "react-i18next";

type ErrorPageProps = {
    httpCode?: string,
    errorTitle?: string,
    errorMessage?: string,
};

const ErrorPage = ({
                       httpCode = "403",
                       errorTitle = "unauthorized",
                       errorMessage = "unauthorizedDesc"
                   }: ErrorPageProps) => {
    const {t} = useTranslation();
    const [cookieErrorMessage, setCookieErrorMessage] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const authError = Cookies.get('authError');
        if (authError) {
            setCookieErrorMessage(authError);
            // clear the cookie after reading it
            Cookies.remove('authError');
        }
    }, []);

    const goBack = () => navigate(-1);

    return (
        <main>
            <div className="max-w-screen-xl mx-auto px-4 flex items-center justify-start h-screen md:px-8">
                <div className="max-w-lg mx-auto space-y-3 text-center">
                    <h3 className="text-arcticBlue font-semibold font-heading uppercase">
                        {httpCode} {t("common.error")}
                    </h3>
                    <p className="text-charcoal text-4xl font-semibold font-heading uppercase sm:text-5xl">
                        {t(`common.${errorTitle}`)}
                    </p>
                    <p className="text-slate">
                        {cookieErrorMessage ? t(`common.${cookieErrorMessage}`) : t(`common.${errorMessage}`)}
                    </p>
                    <div className="flex flex-wrap items-center justify-center gap-3">
                        <button onClick={goBack}
                           className="block py-2 px-4 text-white font-medium font-heading bg-arcticBlue duration-150 hover:bg-arcticBlue/90 active:bg-arcticBlue rounded-lg">
                            {t("common.goBack")}
                        </button>
                        <a target="_blank" href="https://divertmentalhealth.ca/contact/"
                           className="block py-2 px-4 text-slate hover:bg-ash font-medium font-heading duration-150 active:bg-ash border rounded-lg">
                            {t("common.contactUs")}
                        </a>
                    </div>
                </div>
            </div>
        </main>

    );
};

export default ErrorPage;
